import React from 'react';
import styled from 'styled-components';
const Wrapper = styled.div`
  margin-left: 200px;
  margin-right: 6em;
`;
export const NoMatch = () => (
  <Wrapper>
    <h2>No Match</h2>
  </Wrapper>
)